import React, { useState } from 'react';
import styled from 'styled-components';
import { useAuth } from '../context/AuthContext';
import { Button, ErrorText, FormRow, Input, Label, Surface, SurfaceBody, Title } from '../components/ui';
import { theme } from '../theme';

const LoginShell = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  position: relative;
  z-index: 1;
`;

const LoginCard = styled(Surface)`
  width: min(420px, 100%);
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.45), ${theme.colors.glow};
`;

const LoginPage: React.FC = () => {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username, password);
    } catch {
      setError('Credenciales inválidas');
    } finally {
      setLoading(false);
    }
  };

  return (
    <LoginShell>
      <Title style={{ marginBottom: '1.25rem', letterSpacing: '2px' }}>EUGENIAL ADMIN</Title>
      <LoginCard>
        <SurfaceBody>
          <form onSubmit={handleSubmit}>
            <FormRow>
              <Label>Usuario</Label>
              <Input value={username} onChange={(e) => setUsername(e.target.value)} required autoComplete="username" />
            </FormRow>
            <FormRow>
              <Label>Contraseña</Label>
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" />
            </FormRow>
            {error && <ErrorText>{error}</ErrorText>}
            <Button type="submit" disabled={loading} style={{ width: '100%', marginTop: '0.75rem' }}>
              {loading ? 'Ingresando...' : 'Ingresar'}
            </Button>
          </form>
        </SurfaceBody>
      </LoginCard>
    </LoginShell>
  );
};

export default LoginPage;
